<template>
  <div>
    <a-switch size="large" @change="onSwitchChange" :checked="useNewWebsocketLogic" class="mr-2" /><span
      class="text-base"
      >{{ $t("settings.activated") }}</span
    >
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useBoardStore } from "@/store/board/BoardStore";

export default defineComponent({
  name: "NewWebsocket",
  setup() {
    const boardStore = useBoardStore();

    const useNewWebsocketLogic = computed(() => boardStore.useNewWebsocketLogic);

    const onSwitchChange = async () => {
      await boardStore.toggleNewWebsocketLogic();
    };

    return {
      useNewWebsocketLogic,
      onSwitchChange
    };
  }
});
</script>

<style scoped></style>
